import type { Id } from "@repo/db"
import { createFileRoute } from "@tanstack/react-router"

import { DealDetailView } from "../../../components/deal-packets/deal-detail-view"

export const Route = createFileRoute("/$dealership/deal-packets/$dealId/")({
  component: DealDetailPage,
})

function DealDetailPage() {
  const { dealership, stores, user } = Route.useRouteContext()
  const { dealId } = Route.useParams()

  if (!dealership) return null

  return (
    <DealDetailView
      dealId={dealId}
      dealershipSlug={dealership.slug}
      dealershipId={dealership._id}
      userId={user?.userId ?? ("" as Id<"users">)}
      stores={stores}
    />
  )
}
